export default __webpack_public_path__ + "static/media/Thx.7696022b.png";